
import { Sale } from "@/models/base";
import { SaleAwsDocument } from "@/models/base/sale-aws-document";
import { AWSFileService } from "@/services/aws-file-service";
import Vue from "vue";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services/auth-service";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { downloadBlob } from "@/utils/blob";
import AppSaleEditAwsDocumentsOptionsModal from "./SaleEditAwsDocumentsOptionsModal.vue";
import AppSaleEditAwsDocumentsSettings from "./SaleEditAwsDocumentsSettings.vue";
import {UserConfigService} from "@/services";

export default Vue.extend({
	data() {
		return {
			sending: false,
			allFiles: [] as SaleAwsDocument[],
			openedSettingsItem: null as null | SaleAwsDocument,
			settingsModalOpen: false,
			userConf: UserConfigService.getSaleSettings()
		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true
		},
	},
	computed: {
		moduleId():MODULE {
			return MODULE.DOCUMENTENBEHEER;
		},
		hasModule():boolean {
			return AuthService.hasModule(this.moduleId);
		},

	},
	methods: {
		async download(file:SaleAwsDocument){
			if (file.toUploadFile){
				downloadBlob(file.toUploadFile, file.toUploadFile.name);
				return;
			}
			if (!file.File) return;
			await AWSFileService.downloadFile(file.File.Token, file.File.Name);
		},
		onFile(file:File){
			let doc = new SaleAwsDocument();
			doc.toUploadFile = file;
			doc.ShowWithDownload = this.userConf.AWSDocumentManagerAutomaticallyShowWithDownload;
			doc.ShowWithPrint = this.userConf.AWSDocumentManagerAutomaticallyShowWithPrint;
			doc.ShowWithSend = this.userConf.AWSDocumentManagerAutomaticallyShowWithSend;
			this.sale.UnprocessedFiles.push(doc);
			this.allFiles.push(doc);
			if (this.userConf.AWSDocumentManagerAutomaticallyOpenPrintSettingsOnAdd) {
				this.openedSettingsItem = doc;
			}
		},
		removeFile(index:number){
			let file = this.allFiles[index];
			this.allFiles.splice(index, 1);
			let i = this.sale.UnprocessedFiles.indexOf(file);
			if (i != -1) {
				this.sale.UnprocessedFiles.splice(i, 1);
			}
			i = this.sale.AWSDocuments.indexOf(file);
			if (i != -1){
				this.sale.AWSDocuments.splice(i, 1);
				this.sale.toRemoveFiles.push(file);
			}
			i = this.sale.toUpdateFiles.indexOf(file);
			if (i != -1){
				this.sale.toUpdateFiles.splice(i, 1);
			}
		},
		close(){
			this.$emit("close");
		},
		canPreviewFile(file:SaleAwsDocument):boolean{
			if (!file.File) return false;
			if (["application/pdf","image/png","image/jpeg"].includes(file.File.ContentType)) return true;
			return false;
		},
		previewFile(file:SaleAwsDocument){
			if (file.File){
				AWSFileService.previewAwsFile(file.File);
				return;
			}
		},
		getDocName(file:SaleAwsDocument):string {
			if (file.toUploadFile){
				return file.toUploadFile.name;
			}
			if (file.File) {
				return file.File.Name;
			}
			return "<ERROR>";
		},
		toggleShowWithSend(item:SaleAwsDocument){
			item.ShowWithSend = !item.ShowWithSend;
			if (item.ID != 0 && this.sale.toUpdateFiles.indexOf(item) == -1){
				this.sale.toUpdateFiles.push(item);
			}
		},
		toggleShowWithDownload(item:SaleAwsDocument){
			item.ShowWithDownload = !item.ShowWithDownload;
			if (item.ID != 0 && this.sale.toUpdateFiles.indexOf(item) == -1){
				this.sale.toUpdateFiles.push(item);
			}
		},
		toggleShowWithPrint(item:SaleAwsDocument){
			item.ShowWithPrint = !item.ShowWithPrint;
			if (item.ID != 0 && this.sale.toUpdateFiles.indexOf(item) == -1){
				this.sale.toUpdateFiles.push(item);
			}
		},
		onSort(){
			this.allFiles.forEach((item, i)=>{
				item.DisplayOrder = i;
				if (item.ID != 0 && this.sale.toUpdateFiles.indexOf(item) == -1){
					this.sale.toUpdateFiles.push(item);
				}
			});
		},
		loadConfigs(){
			this.userConf = UserConfigService.getSaleSettings();
		}
	},
	created(){
		let allFiles = [...this.sale.AWSDocuments, ...this.sale.UnprocessedFiles];
		for (let file of this.sale.toRemoveFiles){
			let i = this.allFiles.findIndex(f=>f.ID == file.ID);
			if (i == -1) continue;
			allFiles.splice(i, 1);
		}
		this.allFiles = allFiles;
	},
	components: {
		AppMissingModule,
		AppFileUpload,
		AppSaleEditAwsDocumentsOptionsModal,
		AppSaleEditAwsDocumentsSettings
	},
	i18nEx: {
		componentPrefix: "components.aws-documents"
	}
});
